export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11111.67f86058.jpg";